import EndUserPageUIContainer from '../../../../src/containers/EndUserPageUIContainer';
import EndUserFormContainer from '../../../../src/containers/Requests/EndUserFormContainer';
import RequestsLayout from '../../../../src/layouts/Pages/RequestsLayout';

export default function RequestsSubmitSuccesfulPage() {
    return (
        <EndUserPageUIContainer>
            <RequestsLayout>
                <EndUserFormContainer />
            </RequestsLayout>
        </EndUserPageUIContainer>
    );
}
